import React from 'react';
import { newRequestUrl } from '@/constants/urls';
import RibbonMenu from '@/containers/ribbon/RibbonMenu';
import Selectors from '@/requests/hooks/selectors';
import { requestSources } from '@/requests/constants';

const RequestDatasetAccessAction = ({ code, disabled }) => {
  const { newRequestCode } = Selectors.useNewRequestCode();
  return (
    <RibbonMenu
      name="access"
      icon="key"
      message="actions.request.access.short"
      url={newRequestUrl(requestSources.DATASET, code, newRequestCode, '#')}
      className="aridhia-request-dataset-access-action"
      disabled={disabled}
    />
  );
};

export default RequestDatasetAccessAction;
